import React from 'react';

const SkeletonMetric = ({ type }) => {
    return (
        <div className="animate-pulse">
            <div className="rounded-2xl relative shadow-xl shadow-gray-100 w-[320px] flex flex-col justify-center items-center p-4 gap-4">

                <div className="rounded-full bg-gray-100 h-12 w-12"></div>
                <div className="h-4 bg-gray-100 rounded w-full"></div>
                <div className="rounded-full bg-gray-100 h-40 w-40"></div>

                {/* Budget Skeleton */}
                <div className="h-4 bg-gray-100 rounded w-full"></div>
                {/* Labor Cost Skeleton */}
                <div className="h-4 bg-gray-100 rounded w-full"></div>
                {/* NR Expense Skeleton */}
                <div className="h-4 bg-gray-100 rounded w-full"></div>
                {/* Potential Bonus Skeleton */}
                <div className="h-4 bg-gray-100 rounded w-full"></div>
                {/* Hours Skeleton */}
                <div className="h-4 bg-gray-100 rounded w-full"></div>
                <div className="h-4 bg-gray-100 rounded w-full"></div>
                <div className="h-4 bg-gray-100 rounded w-full"></div>

                

            </div>
        </div>
    );
};

export default SkeletonMetric; 